import React from 'react';
import { Helmet } from 'react-helmet';
import { Segment } from 'semantic-ui-react';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

// Global Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import PageTitleAndFilters from 'components/PageTitleAndFilters';
// @ts-ignore
import PageWrapper from 'components/PageWrapper';

// Child Components
// @ts-ignore
import SchemasList from './components/SchemasList';
// @ts-ignore
import SchemasPagination from './components/SchemasPagination';

// Environment
const { REACT_APP_PROJECT_NAME } = process.env;

const Settings = (): React.ReactElement => (
    <ErrorBoundary
        namespace="Settings"
        FallbackComponent={<ErrorBoundaryAlert />}
    >
        <Helmet>
            <title>
                Settings -
                {' '}
                {REACT_APP_PROJECT_NAME}
            </title>
        </Helmet>
        <PageTitleAndFilters
            title="Settings"
            searchInputPlaceholder={null}
            hideFilters
        />
        <PageWrapper width={680}>
            <Segment>
                <SchemasList />
                <SchemasPagination />
            </Segment>
        </PageWrapper>
    </ErrorBoundary>
);

export default Settings;
